module.exports = __webpack_public_path__ + "media/images/file-icons/512/006-record-d833f16d30355b2d1d1413933f4c6406.png";